import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=5376c3fe&"
import script from "./Plan.vue?vue&type=script&lang=ts&"
export * from "./Plan.vue?vue&type=script&lang=ts&"
import style0 from "./Plan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports